import type {
  CarsRemoveFromUserGroupApiData,
  CarsRemoveFromUserGroupApiResponses,
  CarsTransferOwnershipApiData,
  CarsTransferOwnershipApiResponses,
  OwnershipCorrectionApiData,
  OwnershipCorrectionApiResponses,
  OwnershipSaleApiData,
  OwnershipSaleApiResponses,
  OwnershipTransferContextApiData,
  OwnershipTransferContextApiResponses,
  UserGroupMemberListForPartnerApiData,
  UserGroupMemberListForPartnerApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const userGroupCarOwnershipUrls = {
  getUserGroupMembersForPartner: dataEndpoint<
    UserGroupMemberListForPartnerApiData,
    UserGroupMemberListForPartnerApiResponses
  >({
    getUrl: (query) => apiUrl('user-group-members/for-partner/', query)
  }),
  getOwnershipTransferContext: dataEndpoint<OwnershipTransferContextApiData, OwnershipTransferContextApiResponses>({
    getUrl: ({ userGroupId, ...query }) => apiUrl(`user-groups/${userGroupId}/ownership-transfer-context/`, query)
  }),
  postOwnershipSale: responseEndpoint<OwnershipSaleApiData, OwnershipSaleApiResponses>({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/ownership-sale/`),
    getBody: ({ userGroupId: _, ...body }) => body
  }),
  postOwnershipCorrection: responseEndpoint<OwnershipCorrectionApiData, OwnershipCorrectionApiResponses>({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/correct-owner-assignment/`),
    getBody: ({ userGroupId: _, ...body }) => body
  }),
  patchRemoveCarsFromUserGroup: responseEndpoint<CarsRemoveFromUserGroupApiData, CarsRemoveFromUserGroupApiResponses>({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/remove-cars/`),
    getBody: ({ userGroupId: _, ...body }) => body
  }),
  postTransferCarsOwnership: responseEndpoint<CarsTransferOwnershipApiData, CarsTransferOwnershipApiResponses>({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/transfer-cars/`),
    getBody: ({ userGroupId: _, ...body }) => body
  })
};
